var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBotSettings = function SvgBotSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 0h22a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52 17.04s2.75 1.1 4.54 1.1c2.63 0 6.1 3.93 11.57 3.93 5.51 0 9.05-4.78 9.05-4.78",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52 17.04s3.75-2.62 6.4-2.62c3.96 0 8.27 5.54 12.67 5.54 3.16 0 6.09-2.67 6.09-2.67",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52 17.04s2.54 1.12 4.86 1.12c4.75 0 8.2-4.28 12.6-4.28 4.24 0 7.7 3.41 7.7 3.41",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53 17.04h1.9c8.93 0 8.8-7.1 14.2-7.1 4.24 0 9.06 7.35 9.06 7.35",
    opacity: 0.8
  }))));
};
export default SvgBotSettings;